import React from "react";
import { matchPath, Route, Switch, useLocation } from "react-router-dom";

import { Stack, Tab, Tabs } from "@mui/material";
import { MeasureDataTableFilters } from "store/types";

import { DealWide } from "../Deal-monitoring/DealWide";
import { TableComponent } from "./Table-component/TableComponent";

interface DataViewProps {
  goToData: () => void;
  goToDataWide?: () => void;
  dataWidePath?: string;
  showTopInvestors: boolean;
  setShowTopInvestors: (value: boolean) => void;
  setFilters: (data: Partial<MeasureDataTableFilters> | null) => void;
}

export const DataView: React.FC<DataViewProps> = ({
  goToData,
  goToDataWide,
  dataWidePath,
  showTopInvestors,
  setShowTopInvestors,
  setFilters
}) => {
  const { pathname } = useLocation();

  return (
    <Stack height="100%" sx={{ overflowY: "hidden" }}>
      {dataWidePath && goToDataWide && (
        <Tabs
          value={matchPath(pathname, dataWidePath) ? "wide" : "long"}
          sx={{ minHeight: 36, mb: "12px", borderBottom: "1px solid #dae0e2", ".vertical-stick": { m: "auto 4px" } }}
        >
          <Tab value="long" label="Long" onClick={goToData} sx={{ textTransform: "none", minHeight: 36, padding: "6px 0" }} />
          <Tab value="wide" label="Wide" onClick={goToDataWide} sx={{ textTransform: "none", minHeight: 36, padding: "6px 12px" }} />
        </Tabs>
      )}
      <Switch>
        {dataWidePath && (
          <Route path={dataWidePath} render={() => <DealWide editable={false} />} />
        )}
        <Route
          render={() => (
            <TableComponent
              showTopInvestors={showTopInvestors}
              setShowTopInvestors={setShowTopInvestors}
              setFilters={setFilters}
            />
          )}
        />
      </Switch>
    </Stack>
  );
};
